import { Topic } from '../model/Topic';
import { firestore } from "./Firebase"

export const getTopics = async () => {
    const doc = await firestore.doc("meta/math").get();
    const topics: Topic[] = doc.data()?.topics ?? [];

    return topics;
};
